/* eslint-disable arrow-body-style */
import axios from 'axios';

import common from '~/common';
import { logError } from '~/common/utils';
const developIp = `${common.Ip.Actions}/v2`;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
///
const clearKey = (dispatch, { key = '' }) => dispatch({ type: 'clear', label: key });
// 忘記密碼
const clearPsdKey = (dispatch, { key = '' }) => dispatch({ type: 'PSD_clear', label: key });
const postCheckEmail = (dispatch, { body }) => {
  axios.post(`${developIp}/user/email/check/`, body)
    .then(res => {
      dispatch({ type: 'PSD_post', body: res.data, label: 'CheckEmail' });
    })
    .catch(error => {
      logError(error, 'postCheckEmail');
      dispatch({ type: 'PSD_post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'CheckEmail' });
    });
};
const getCurrentTokenAccount = (dispatch, { token }) => {
  axios.post(`${developIp}/user/change/passwd/validate/`, { token })
    .then(res => {
      dispatch({ type: 'PSD_post', body: res.data, label: 'CurrentAccount' });
    })
    .catch(error => {
      logError(error, 'getCurrentTokenAccount');
      const errorMessage = error.response?.data?.message || error.message || '發生錯誤，請稍後再試。';
      const errorCode = error.response?.data?.status || '500';
      dispatch({ type: 'PSD_post', body: { status: errorCode, message: errorMessage }, label: 'CurrentAccount' });
    });
};
const putNewPsd = (dispatch, { body }) => {
  axios.put(`${developIp}/user/passwd/`, body)
    .then(res => {
      dispatch({ type: 'PSD_post', body: res.data, label: 'NewPsd' });
    })
    .catch(error => {
      logError(error, 'putNewPsd');
      const errorMessage = error.response?.data?.message || error.message || '發生錯誤，請稍後再試。';
      const errorCode = error.response?.data?.status || '500';
      dispatch({ type: 'PSD_post', body: { status: errorCode, message: errorMessage }, label: 'NewPsd' });
    });
};
// 登入
const postLogin = (dispatch, { account, passwd, valid_code, valid_id }) => {
  axios.post(`${developIp}/user/login/`, {
    account,
    passwd,
    valid_code,
    valid_id,
  })
    .then(res => {
      if (res.data.status === '200') {
        console.log('login',res.data.data);
        const { need_change_pad = false } = res.data.data;
        if (!need_change_pad) {
          localStorage.setItem('token', res.data.data.token);
          localStorage.setItem('refresh_token', res.data.data.refresh_token);
          getJwtCheck(dispatch);
        }
      }
      dispatch({ type: 'session', body: res.data });
    })
    .catch(error => {
      logError(error, 'postLogin');
      const errorMessage = error.response?.data?.message || error.message || '發生錯誤，請稍後再試。';
      const errorCode = error.response?.data?.status || '500';
      dispatch({ type: 'session', body: { status: errorCode, message: errorMessage }, label: 'Login' });
    });
};

const getLogout = dispatch => {
  axios.get(`${developIp}/user/logout/`, getHeaders())
    .then(res => {
    })
    .catch(error => {
      logError(error, 'getLogout');
    });
};
const clearSession = () => ({ type: 'session', body: {} });
const getSystemCount = dispatch => {
  axios.get(`${developIp}/system/count/`)
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data.visitor_count, label: 'SystemCount' });
      }
    })
    .catch(error => {
      logError(error, 'getSystemCount');
    });
};
const getLoginCaptcha = dispatch => {
  axios.get(`${developIp}/captcha/`)
    .then(res => {
      if (res.data.status === '200') {
        const d = new Date();
        d.setMinutes(d.getMinutes() + 14);// 期限為15分鐘
        const body = {
          ...res.data.data,
          deadline: d,
        };
        dispatch({ type: 'post', body, label: 'LoginCaptcha' });
      }
    })
    .catch(error => {
      logError(error, 'getLoginCaptcha');
    });
};
// JWT
const clearJwtKey = (dispatch, { key = '' }) => dispatch({ type: 'JWT_clear', label: key });
const getJwtCheck = dispatch => {
  axios.get(`${developIp}/jwt/check/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'JWT_post', body: res.data.data, label: 'Check' });
      }
    })
    .catch(error => {
      logError(error, 'getJwtCheck');
    });
};
const getJwTNewToken = dispatch => {
  axios.post(`${developIp}/jwt/refresh/`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('refresh_token')}` } })
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'session', body: res.data });
        localStorage.setItem('token', res.data.data.token);
        localStorage.setItem('refresh_token', res.data.data.refresh_token);
        getJwtCheck(dispatch);
      }
      dispatch({ type: 'JWT_post', body: res.data, label: 'NewToken' });
    })
    .catch(error => {
      logError(error, 'getJwTNewToken');
      dispatch({ type: 'JWT_post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'NewToken' });
    });
};
// 樹狀圖
const getAtyFunction = dispatch => {
  axios.get(`${developIp}/privilege/functions/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'AtyFunction' });
        try {
          const { functions = [] } = res.data.data;
          const ary_path = [];
          const handleList = (l = [], func = () => {}) => {
            for (const o of l) {
              if (o.check)func(o.value);
              if ((o.list || []).length > 0)handleList(o.list, func);
            }
          };
          handleList(functions, value => ary_path.push(value));
          dispatch({ type: 'post', body: ary_path, label: 'PathAry' });
        } catch (error) {
          dispatch({ type: 'post', body: [], label: 'PathAry' });
        }
        try {
          dispatch({ type: 'post', body: res.data.data.windcontracts.sort((a, b) => a.order_num - b.order_num), label: 'SwitchProjectList' });
        } catch (error) {
          dispatch({ type: 'post', body: [], label: 'SwitchProjectList' });
        }
      }
    })
    .catch(error => {
      logError(error, 'getAtyFunction');
    });
};
// 導引列尾端
const setPageText = (dispatch, { text = '' }) => {
  dispatch({ type: 'post', body: text, label: 'PageText' });
};
// 帳號管理/使用者維護管理
const getUserList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/user/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'UserList' });
      }
    })
    .catch(error => { logError(error, 'getUserList'); });
};
const getOrgList = dispatch => {
  axios.get(`${developIp}/code/org/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'OrgList' });
      }
    })
    .catch(error => { logError(error, 'getOrgList'); });
};
const getGroupList = dispatch => {
  axios.get(`${developIp}/code/groups/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'GroupList' });
      }
    })
    .catch(error => { logError(error, 'getGroupList'); });
};
const getOrgActList = (dispatch, { id }) => {
  axios.get(`${developIp}/org/${id}/accounts/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'OrgActList' });
      }
    })
    .catch(error => { logError(error, 'getOrgActList'); });
};
const getUserIdDetail = (dispatch, { id }) => {
  axios.get(`${developIp}/user/${id}/detail/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'UserIdDetail' });
      }
    })
    .catch(error => { logError(error, 'getUserIdDetail'); });
};
const clearUserIdDetail = dispatch => dispatch({ type: 'clear', label: 'UserIdDetail' });
const deleteUser = (dispatch, { id }) => {
  axios.put(`${developIp}/user/delete/`, { id }, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'DeleteUser' });
    })
    .catch(error => {
      logError(error, 'deleteUser');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'DeleteUser' });
    });
};
const postAddNewUser = (dispatch, { body }) => {
  axios.post(`${developIp}/user/addNew/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PostAddNewUser' });
    })
    .catch(error => {
      logError(error, 'postAddNewUser');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PostAddNewUser' });
    });
};
const putUpdateUser = (dispatch, { id, body }) => {
  axios.put(`${developIp}/user/${id}/update/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PutUpdateUser' });
    })
    .catch(error => {
      logError(error, 'putUpdateUser');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PutUpdateUser' });
    });
};

// 帳號管理/個人資料維護管理
const getOneself = dispatch => {
  axios.get(`${developIp}/user/detail/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'Oneself' });
      }
    })
    .catch(error => { logError(error, 'getOneself'); });
};
const clearOneself = dispatch => {
  dispatch({ type: 'clear', label: 'Oneself' });
};
const putOneSelf = (dispatch, { body }) => {
  axios.put(`${developIp}/user/update/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'Res_PutOneSelf' });
    })
    .catch(error => {
      logError(error, 'putOneSelf');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'Res_PutOneSelf' });
    });
};
const putUserCheck = (dispatch, { body, id }) => {
  axios.put(`${developIp}/user/check/log/${id}/active/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'Res_PutUserCheck' });
    })
    .catch(error => {
      logError(error, 'putUserCheck');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'Res_PutUserCheck' });
    });
};

// 組織管理
const getOrgPageList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/org/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'OrgPageList' });
      }
    })
    .catch(error => { logError(error, 'getOrgPageList'); });
};
const getOrgIdDetail = (dispatch, { id }) => {
  axios.get(`${developIp}/org/${id}/detail/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'OrgIdDetail' });
      }
    })
    .catch(error => { logError(error, 'getOrgIdDetail'); });
};
const getPickOrgList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/org/temp/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'PickOrgList' });
      }
    })
    .catch(error => { logError(error, 'getPickOrgList'); });
};
const getWindList = dispatch => {
  axios.get(`${`${common.Ip.Actions}/v3`}/code/windcontract/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'WindList' });
      }
    })
    .catch(error => { logError(error, 'getWindList'); });
};
const deleteOrg = (dispatch, { id }) => {
  axios.delete(`${developIp}/org/delete/`, { ...getHeaders(), data: { id } })
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'DeleteOrg' });
    })
    .catch(error => {
      logError(error, 'deleteOrg');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'DeleteOrg' });
    });
};
const postAddNewOrg = (dispatch, { body }) => {
  axios.post(`${developIp}/org/addNew/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PostAddNewOrg' });
    })
    .catch(error => {
      logError(error, 'postAddNewOrg');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PostAddNewOrg' });
    });
};
const putUpdateOrg = (dispatch, { id, body }) => {
  axios.put(`${developIp}/org/${id}/update/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PutUpdateOrg' });
    })
    .catch(error => {
      logError(error, 'putUpdateOrg');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PutUpdateOrg' });
    });
};

// 權限管理
const getAtyPageList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/privilege/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'AtyPageList' });
      }
    })
    .catch(error => { logError(error, 'getAtyPageList'); });
};
const getRoleTypeList = dispatch => {
  axios.get(`${developIp}/code/role_type/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'RoleTypeList' });
      }
    })
    .catch(error => { logError(error, 'getRoleTypeList'); });
};
const getAryIdDetail = (dispatch, { id }) => {
  axios.get(`${developIp}/privilege/${id}/detail/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'AryIdDetail' });
      }
    })
    .catch(error => { logError(error, 'getAryIdDetail'); });
};
const deleteAry = (dispatch, { id }) => {
  axios.delete(`${developIp}/privilege/delete/`, { ...getHeaders(), data: { id } })
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'DeleteAry' });
    })
    .catch(error => {
      logError(error, 'deleteAry');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'DeleteAry' });
    });
};
const postAddNewAry = (dispatch, { body }) => {
  axios.post(`${developIp}/privilege/addNew/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PostAddNewAry' });
    })
    .catch(error => {
      logError(error, 'postAddNewAry');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PostAddNewAry' });
    });
};
const putUpdateAry = (dispatch, { id, body }) => {
  axios.put(`${developIp}/privilege/${id}/update/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PutUpdateAry' });
      getAtyFunction(dispatch);
    })
    .catch(error => {
      logError(error, 'putUpdateAry');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PutUpdateAry' });
    });
};

// 帳號清查 - 清查作業
const getCheckPageList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/user/check/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'CheckPageList' });
      }
    })
    .catch(error => { logError(error, 'getCheckPageList'); });
};
const getCheckIdDetail = (dispatch, { id }) => {
  axios.get(`${developIp}/user/check/${id}/detail/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'CheckIdDetail' });
      }
    })
    .catch(error => { logError(error, 'getCheckIdDetail'); });
};
const postAddNewCheck = (dispatch, { body }) => {
  axios.post(`${developIp}/user/check/addNew/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PostAddNewCheck' });
    })
    .catch(error => {
      logError(error, 'postAddNewCheck');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PostAddNewCheck' });
    });
};
const putUpdateCheck = (dispatch, { id, body }) => {
  axios.put(`${developIp}/user/check/update/${id}/detail/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PutUpdateCheck' });
    })
    .catch(error => {
      logError(error, 'putUpdateCheck');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PutUpdateCheck' });
    });
};
const getCheckIdPageList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/user/check/log/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'CheckIdPageList' });
      }
    })
    .catch(error => { logError(error, 'getCheckIdPageList'); });
};
const exportCheckIdExcel = (dispatch, { name = '', id }) => {
  axios.get(`${developIp}/user/check/${id}/export/excel/path/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        window.location.assign(res.data.data.path);
      }
    })
    .catch(error => { logError(error, 'exportCheckIdExcel'); });
};
const putActiveCheck = (dispatch, { id }) => {
  axios.put(`${developIp}/user/check/${id}/active/`, {}, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PutActiveCheck' });
    })
    .catch(error => {
      logError(error, 'putActiveCheck');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PutActiveCheck' });
    });
};

// 帳號清查 - 通知信維護
const getMsgUser = dispatch => {
  axios.get(`${developIp}/message/user/check/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data, label: 'MsgUser' });
      }
    })
    .catch(error => { logError(error, 'getMsgUser'); });
};
const getLMsgUser = (dispatch, { version = 0 }) => {
  axios.get(`${developIp}/message/user/check/${version}/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data, label: 'LMsgUser' });
      }
    })
    .catch(error => { logError(error, 'getLMsgUser'); });
};
const postUpdateMail = (dispatch, { body }) => {
  axios.post(`${developIp}/message/user/check/update/`, body, getHeaders())
    .then(res => {
      dispatch({ type: 'post', body: res.data, label: 'PostUpdateMail' });
    })
    .catch(error => {
      logError(error, 'postUpdateMail');
      dispatch({ type: 'post', body: { status: '500', message: '發生錯誤，請稍後再試。' }, label: 'PostUpdateMail' });
    });
};
// 日誌管理
const getActionList = dispatch => {
  axios.get(`${developIp}/code/active/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'ActionList' });
      }
    })
    .catch(error => { logError(error, 'getActionList'); });
};
const getFuncList = dispatch => {
  axios.get(`${developIp}/code/functions/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'FuncList' });
      }
    })
    .catch(error => { logError(error, 'getFuncList'); });
};
const getAccountList = dispatch => {
  axios.get(`${developIp}/code/account/`, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'AccountList' });
      }
    })
    .catch(error => { logError(error, 'getAccountList'); });
};
const getNotePageList = (dispatch, { page, per_page, body }) => {
  axios.post(`${developIp}/active/list/${page}/${per_page}/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        dispatch({ type: 'post', body: res.data.data, label: 'NotePageList' });
      }
    })
    .catch(error => { logError(error, 'getNotePageList'); });
};
const exportNoteExcel = (dispatch, { body }) => {
  axios.post(`${developIp}/active/check/export/path/`, body, getHeaders())
    .then(res => {
      if (res.data.status === '200') {
        window.location.assign(res.data.data.path);
      }
    })
    .catch(error => { logError(error, 'exportNoteExcel'); });
};

// 時間審核
const openCheckTime = dispatch => dispatch({ type: 'post', body: true, label: 'CheckTime' });


// 報表管理/取得發送清單
const getReportMailList = (dispatch, { page, per_page, body }) => {
  axios.get(`${developIp}/schedule/report/user_emails/page_index/${page}/page_size/${per_page}/list/new/v2/`, getHeaders())
    .then(res => {
      if (res.data.status === '200' || res.data.status === 200) {
        dispatch({ type: 'post', body: res.data.data, label: 'ReportMailList' });
      }
    })
    .catch(error => { logError(error, 'getReportMailList'); });
};

// 報表管理/新增報表Email
const addReportMail = ({ body }) => {
  return new Promise((resolve, reject) => {
    axios.post(`${developIp}/schedule/report/user_email/new/v2/`, body, getHeaders())
      .then(res => {
        if (res.data.status === '200' || res.data.status === 200) {
          resolve({ success: true });
        } else {
          resolve({ success: false, error: res.data.error });
        }
      })
      .catch(error => {
        logError(error, 'addReportMail');
        reject({ success: false, error: res.data.error });
      });
  });
};

// 報表管理/修改報表Email
const updateReportMail = ({ body }) => {
  return new Promise((resolve, reject) => {
    axios.put(`${developIp}/schedule/report/user_email/details/new/v2/`, body, getHeaders())
      .then(res => {
        if (res.data.status === '200' || res.data.status === 200) {
          resolve({ success: true });
        } else {
          resolve({ success: false, error: res.data.error });
        }
      })
      .catch(error => {
        logError(error, 'updateReportMail');
        reject({ success: false, error: res.data.error });
      });
  });
};

// 報表管理/刪除一筆報表Email紀錄
const deleteReportMail = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${developIp}/schedule/report/user_email/id/${id}/new/v2/`, getHeaders())
      .then(res => {
        if (res.data.status === '200' || res.data.status === 200) {
          resolve({ success: true });
        } else {
          resolve({ success: false, error: res.data.error });
        }
      })
      .catch(error => {
        logError(error, 'deleteReportMail');
        reject({ success: false, error: res.data.error });
      });
  });
};


const actions = {
  clearKey,
  // 忘記密碼
  clearPsdKey,
  postCheckEmail,
  getCurrentTokenAccount,
  putNewPsd,
  // 登入
  postLogin,
  getLogout,
  clearSession,
  getSystemCount,
  getLoginCaptcha,
  // JWT
  clearJwtKey,
  getJwtCheck,
  getJwTNewToken,
  // 樹狀圖
  getAtyFunction,
  // 導引列尾端
  setPageText,
  // 帳號管理/使用者維護管理
  getUserList,
  getOrgList,
  clearOneself,
  getGroupList,
  getOrgActList,
  deleteUser,
  postAddNewUser,
  putUpdateUser,
  getUserIdDetail,
  clearUserIdDetail,
  // 帳號管理/個人資料維護管理
  getOneself,
  putOneSelf,
  putUserCheck,
  // 組織管理
  getOrgPageList,
  getOrgIdDetail,
  getPickOrgList,
  getWindList,
  deleteOrg,
  postAddNewOrg,
  putUpdateOrg,
  // 權限管理
  getAtyPageList,
  getRoleTypeList,
  getAryIdDetail,
  deleteAry,
  postAddNewAry,
  putUpdateAry,
  // 帳號清查 - 清查作業
  getCheckPageList,
  getCheckIdDetail,
  postAddNewCheck,
  putUpdateCheck,
  getCheckIdPageList,
  exportCheckIdExcel,
  putActiveCheck,
  // 帳號清查 - 通知信維護
  getMsgUser,
  getLMsgUser,
  postUpdateMail,
  // 日誌管理
  getActionList,
  getFuncList,
  getAccountList,
  getNotePageList,
  exportNoteExcel,
  // 時間審核
  openCheckTime,
  //報表管理
  getReportMailList,
  addReportMail,
  updateReportMail,
  deleteReportMail,
};
export default actions;
